import i18next from 'i18next'
import {memo} from 'react'
import dateformat from 'src/utils/dateformat'

interface Props {
  items: any[]
  rowNumber: number
}

// eslint-disable-next-line react/display-name
export const RowData = memo(({items, rowNumber}: Props) => {
  return (
    <>
      {items.map((item, idx) => (
        <tr key={item?.id ?? idx}>
          <td>{item?.sales_org.name}</td>
          <td>{item?.customer_code}</td>
          <td>{item?.customer_name}</td>
          <td>{item?.so_number}</td>
          <td>{item?.do_number}</td>
          <td>{item?.delivery_item}</td>
          <td>{dateformat(item?.do_date)}</td>
          <td>{item?.material_number}</td>
          <td>{item?.product_type?.product_type}</td>
          <td>{item?.plant}</td>
          <td>{item?.plant_desc}</td>
          <td>
            {i18next.language === 'en'
              ? item?.qty?.toLocaleString('en', {maximumFractionDigits: 4})
              : item?.qty?.toLocaleString('id', {maximumFractionDigits: 4})}
          </td>
        </tr>
      ))}
    </>
  )
})
